export default __webpack_public_path__ + "static/media/faithfulofset.f802a299.png";